import Vue from 'vue';
import Vuex from 'vuex';
import scheduleAdapter from '@/adapters/schedule';

Vue.use(Vuex);

const COMPANY_ID = 35912;
const SOURCE_ID = 2;

export default new Vuex.Store({
  state: {
    schedule: [],
    fullname: '',
    phone: '',
    scheduleId: null,
    trainingId: null,
    enrollTraining: null,
    isCameFromSchedule: false,
  },
  getters: {
    getScheduleById: (state) => (id) => state.schedule.find((el) => el.id === id),
    getTrainingsByScheduleId: (state, getters) => (id) => {
      const schedule = getters.getScheduleById(id);
      const { trainings = [] } = schedule || {};
      return trainings.reduce((acc, item) => {
        const findedItem = acc.find((el) => el.trainingId === item.trainingId);
        if (!findedItem) {
          acc.push(item);
        }
        return acc;
      }, []);
    },
  },
  mutations: {
    setSchedule(state, schedule) {
      state.schedule = schedule;
    },
    setFullname(state, fullname) {
      state.fullname = fullname;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setScheduleId(state, scheduleId) {
      state.scheduleId = scheduleId;
    },
    setTrainingId(state, trainingId) {
      state.trainingId = trainingId;
    },
    setEnrollTraining(state, training) {
      state.enrollTraining = training;
    },
    setCameFlag(state, flag) {
      state.isCameFromSchedule = flag;
    },
    clearSchedule(state) {
      state.schedule = [];
    },
    clearFullname(state) {
      state.fullname = '';
    },
    clearPhone(state) {
      state.phone = '';
    },
    clearEnrollTraining(state) {
      state.enrollTraining = null;
    },
    clearIds(state) {
      state.scheduleId = null;
      state.trainingId = null;
    },
  },
  actions: {
    fetchSchedule({ commit }) {
      const params = {
        company_id: COMPANY_ID,
        source_id: SOURCE_ID,
      };
      return this.$axios.get('/m/schedule', { params })
        .then(({ data }) => {
          const schedule = (data || [])
            .map(scheduleAdapter)
            .filter((el) => !el.isHidden)
            .sort((one, two) => one.position - two.position);
          commit('setSchedule', schedule);
        });
    },
    enrollToTraining({ state }) {
      const params = {
        company_id: COMPANY_ID,
        source_id: SOURCE_ID,
        training_id: state.enrollTraining?.id,
        phone: state.phone,
        fio: state.fullname,
        msg: '',
        timezone_offset: -180,
        subscribe: 1,
      };
      return this.$axios.post('/m/schedule/subscribe', null, { params })
        .then(({ data }) => data?.error || '');
    },
    clearSession({ commit }) {
      commit('clearSchedule');
      commit('clearFullname');
      commit('clearPhone');
      commit('clearEnrollTraining');
      commit('clearIds');
      commit('setCameFlag', false);
    },
  },
  modules: {},
  plugins: [],
});
